"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "useAvailabilityTilesService", {
  enumerable: true,
  get: function () {
    return _useAvailabilityTilesService.default;
  }
});
var _useAvailabilityTilesService = _interopRequireDefault(require("./useAvailabilityTilesService"));